import { useEffect, useMemo, useSyncExternalStore } from "react";
import { api, session } from "./api";
import { createNotificationSummaryStore, startNotificationSummaryRefresh } from "./notifications-store";
export const NOTIFICATIONS_CHANGED = "agent:notifications-changed";
export const notifyNotificationsChanged = () => window.dispatchEvent(new Event(NOTIFICATIONS_CHANGED));
export function useNotificationSummary(agentId?: number) {
  const store = useMemo(() => createNotificationSummaryStore(async () => {
    if (!agentId || !session.get()) return undefined;
    const result = await api<{ unread_count: number }>("/notifications/summary");
    return result.unread_count;
  }), [agentId]);
  const count = useSyncExternalStore(store.subscribe, store.getSnapshot);
  useEffect(() => {
    if (!agentId) return;
    return startNotificationSummaryRefresh({
      windowEvents: window,
      documentEvents: document,
      isVisible: () => document.visibilityState === "visible",
      isAuthorized: () => !!agentId && !!session.get(),
      refresh: store.refresh,
      reset: store.reset,
      setInterval: (callback, milliseconds) => window.setInterval(callback, milliseconds),
      clearInterval: (id) => window.clearInterval(id),
    });
  }, [store, agentId]);
  return { count, refresh: store.refresh };
}
